import { apiInstance } from '../api';

const route = '/residentialComplex/admin';

export class ComplexesService {
  // search, missing (description | photo | address | deadline | developer | curator), stock (onSale | none), sort, page, limit
  static async fetchAdminList(params) {
    return apiInstance.get(`${route}/list`, { params })
  }

  // the card editor: { card, editable, flats: { total, onSale }, eciOldIds }
  static async fetchCard(id) {
    return apiInstance.get(`${route}/${id}`)
  }

  // only the changed fields; answers the saved card
  static async updateCard(id, changes) {
    return apiInstance.put(`${route}/${id}`, changes)
  }

  static async createCard(values) {
    return apiInstance.post(route, values)
  }

  // one photo or document into a file field (otherImages: one more photo); answers the saved card
  static async uploadFile(id, field, file) {
    const formData = new FormData()
    formData.append('file', file)
    return apiInstance.post(`${route}/${id}/file/${field}`, formData)
  }

  static async deleteCard(id) {
    return apiInstance.delete(`${route}/${id}`)
  }
}
